import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../appSettings/AppSettingsService';

declare var ga;

@Component({
    selector: 'cl-google-analytics',
    template: ''
})
export class GoogleAnalyticsComponent implements OnInit {
    static $name: string = 'clGoogleAnalytics';

    constructor(private appSettingsService: AppSettingsService) {
    }

    ngOnInit() {
        let metadata = this.appSettingsService.getMetadata();
        let analyticsKey = metadata.analyticsKey;

        if (analyticsKey) {
            let dimensions = metadata.dimensions;

            // tslint:disable
            (function(i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function() {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * (new Date() as any); a = s.createElement(o),
                    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
            // tslint:enable

            ga('create', analyticsKey, 'auto');

            for (let i = 0; i < dimensions.length; i++) {
                ga('set', 'dimension' + (i + 1), dimensions[i]);
            }

            ga('send', 'pageview');
        }
    }
}
